import { render } from "./confirmPayDiy.vue?vue&type=template&id=fbec0508&scoped=true"
import script from "./confirmPayDiy.vue?vue&type=script&lang=js"
export * from "./confirmPayDiy.vue?vue&type=script&lang=js"

import "./confirmPayDiy.vue?vue&type=style&index=0&id=fbec0508&scoped=true&lang=scss"
import "./confirmPayDiy.vue?vue&type=style&index=1&id=fbec0508&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbec0508"]])

export default __exports__